const tutorialContent = {
  tut1: {
    title: '',
    message: 'Welcome %{user}! Let’s get started now.',
  },
  tut2: {
    title: 'MENU',
    message:
      'The menu covers all components in FiinTrade. ?Customize the workspace by dragging and dropping components one by one.',
  },
  tut3: {
    title: 'WORKSPACE',
    message:
      'Choose sample workspaces created by FiinTrade or create your own workspace for different purposes.',
  },
  tut4: {
    title: 'SETTING',
    message: 'Modify and update your personal information anytime.',
  },
  tut5: {
    title: 'QUICK COMPONENT',
    message:
      'Quick Component includes 10 most used components. Choose ones that fits you best for more convenient trading process.',
  },
  tut6: {
    title: 'SEARCH BOX',
    message: 'Search on tickers and everything related in one click.',
  },
  tut7: {
    title: 'LANGUAGE',
    message:
      'Use FiinTrade in the language your prefer. There are Vietnamese, English and counting more in the future.',
  },
  tut8: {
    title: 'DARK / LIGHT MODE',
    message:
      'Tune the experience the way you like. Light and dark FiinTrade has it all.',
  },
};

export default {
  tutorialContent,
};
